import axios from 'axios';
import store from '../store';
import config from '../config/server';

const axiosRequestErrorInterceptor = (err, instance) => {
  if (err.response
    && err.response.data
     && err.response.data.error
      && err.response.data.error.code === 5) {
    return store
      .dispatch('auth/refreshToken', { refreshToken: store.state.auth.refreshToken })
      .then(() => {
        // rewrite the current Authorization header
        instance.defaults.headers.Authorization = `Bearer ${store.state.auth.token}`;
        err.config.headers.Authorization = instance.defaults.headers.Authorization;

        return axios(err.config)
          .then((response) => Promise.resolve(response))
          .catch((response) => Promise.reject(response));
      })
      .catch((error) => Promise.reject(error));
  }

  return Promise.reject(err);
};

export function createAxiosInstance() {
  const instance = axios.create({
    baseURL: config.apiBaseURL,
    timeout: 10000,
    headers: {
      Authorization: store.state.auth.token ? `Bearer ${store.state.auth.token}` : null,
    },
  });


  // Add a response interceptor
  instance.interceptors.response.use((response) => response, (err) => axiosRequestErrorInterceptor(
    err,
    instance,
  ));

  return instance;
}
